import { createApi } from '@reduxjs/toolkit/query/react';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';
import type {
    GetMemberVacationModeApiResponse,
    SaveMemberVacationModeApiRequest,
    SaveMemberVacationModeApiResponse,
} from 'tradera/state/services/types/webapi-member-generated';

export const vacationModeApi = createApi({
    reducerPath: 'vacationModeApi',
    baseQuery: isomorphicWebApiBaseQuery,
    tagTypes: ['VacationMode'],
    endpoints: (builder) => ({
        getVacationMode: builder.query<GetMemberVacationModeApiResponse, void>({
            query: () => ({
                url: `/api/webapi/member/vacation-mode`,
            }),
            providesTags: [{ type: 'VacationMode' }],
        }),
        updateVacationMode: builder.mutation<
            SaveMemberVacationModeApiResponse,
            SaveMemberVacationModeApiRequest
        >({
            query: (body) => {
                return {
                    url: `/api/webapi/member/vacation-mode`,
                    method: 'POST',
                    body,
                };
            },
            invalidatesTags: [{ type: 'VacationMode' }],
        }),
        deleteVacationMode: builder.mutation<
            SaveMemberVacationModeApiResponse,
            void
        >({
            query: () => {
                return {
                    url: `/api/webapi/member/vacation-mode`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: [{ type: 'VacationMode' }],
        }),
    }),
});

export const {
    useGetVacationModeQuery,
    useUpdateVacationModeMutation,
    useDeleteVacationModeMutation,
} = vacationModeApi;
